exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sbwXHA1t1NpK1k5gv0Bt9{font-size:16px;font-weight:900;line-height:1.1;width:100%}.sbwXHA1t1NpK1k5gv0Bt9 a{color:inherit}._2kmH2ZwetpUSY01KtESrEw{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.egeecXcD3ucUqe4ygxn9S{background-position:50%;background-repeat:no-repeat;background-size:cover;width:50px;height:50px;position:absolute;left:0;top:0;-webkit-box-flex:0;-webkit-flex:0;-ms-flex:0;flex:0}.EOo4OI8AMJtzGy4Ynpeb8{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;min-height:50px;padding-left:60px;position:relative;text-align:left;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);

// exports
exports.locals = {
	"avatarSize": "50px",
	"username": "sbwXHA1t1NpK1k5gv0Bt9",
	"usernameTruncate": "_2kmH2ZwetpUSY01KtESrEw sbwXHA1t1NpK1k5gv0Bt9",
	"avatar": "egeecXcD3ucUqe4ygxn9S",
	"header": "EOo4OI8AMJtzGy4Ynpeb8"
};